import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function EventsWidget() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  useEffect(() => { fetch(`${API}/public/events`).then(r => r.json()).then(d => { setItems(d.items || []); if (d.error) setError(d.error); }).catch(() => setError(t('widgets.unavailable'))); /* eslint-disable-next-line */ }, []);
  return (
    <div className="bg-white dark:bg-[#0f172a] rounded-xl p-5 border border-gray-100 dark:border-gray-800" data-testid="events-widget">
      <h3 className="text-sm font-bold uppercase tracking-wider text-gray-900 dark:text-gray-100 border-l-4 border-red-600 pl-3 mb-4 flex items-center gap-2"><Calendar size={14} /> {t('widgets.events_label')}</h3>
      {error && items.length === 0 ? <p className="text-xs text-gray-400 dark:text-gray-500">{error}</p> :
        items.length === 0 ? <p className="text-xs text-gray-400 dark:text-gray-500">{t('widgets.no_events')}</p> :
        <div className="space-y-3">{items.slice(0, 5).map((e, i) => (
          <a key={i} href={e.url} target="_blank" rel="noopener noreferrer" className="group block">
            <h4 className="text-[13px] font-medium text-gray-800 dark:text-gray-100 group-hover:text-red-600 line-clamp-2">{e.title}</h4>
            {e.date && <span className="text-[10px] text-gray-400 dark:text-gray-500">{e.date}</span>}
          </a>
        ))}</div>}
      <a href="https://www.evento.sh/ck" target="_blank" rel="noopener noreferrer" className="text-[11px] text-red-600 dark:text-red-400 mt-3 block font-medium">{t('widgets.see_all')} &rarr;</a>
    </div>
  );
}

export function SportsWidget() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  useEffect(() => { fetch(`${API}/public/sports`).then(r => r.json()).then(d => { setItems(d.items || []); if (d.error) setError(d.error); }).catch(() => setError(t('widgets.unavailable'))); /* eslint-disable-next-line */ }, []);
  return (
    <div className="bg-white dark:bg-[#0f172a] rounded-xl p-5 border border-gray-100 dark:border-gray-800" data-testid="sports-widget">
      <h3 className="text-sm font-bold uppercase tracking-wider text-gray-900 dark:text-gray-100 border-l-4 border-orange-500 pl-3 mb-4">{t('widgets.sports_label')}</h3>
      {error && items.length === 0 ? <p className="text-xs text-gray-400 dark:text-gray-500">{error}</p> :
        items.length === 0 ? <p className="text-xs text-gray-400 dark:text-gray-500">{t('widgets.no_results')}</p> :
        <ul className="space-y-3">{items.slice(0, 6).map((m, i) => (
          <li key={i} className="flex gap-3 pb-3 border-b border-gray-50 dark:border-gray-800 last:border-0 last:pb-0">
            {m.image_url && <img src={m.image_url} alt="" className="w-14 h-14 rounded object-cover shrink-0" />}
            <a href={m.link} target="_blank" rel="noopener noreferrer" className="text-xs font-medium text-gray-800 dark:text-gray-100 hover:text-orange-600 dark:hover:text-orange-400 line-clamp-3 leading-snug">{m.title}</a>
          </li>
        ))}</ul>}
    </div>
  );
}

export function HoroscopeWidget() {
  const { t } = useTranslation();
  const [horoscopes, setHoroscopes] = useState([]);
  const [selected, setSelected] = useState(0);
  useEffect(() => { fetch(`${API}/public/horoscope`).then(r => r.json()).then(d => setHoroscopes(d.horoscopes || [])).catch(() => {}); }, []);
  if (horoscopes.length === 0) return null;
  const current = horoscopes[selected];
  return (
    <div className="bg-white dark:bg-[#0f172a] rounded-xl p-5 border border-gray-100 dark:border-gray-800" data-testid="horoscope-widget">
      <h3 className="text-sm font-bold uppercase tracking-wider text-gray-900 dark:text-gray-100 border-l-4 border-purple-500 pl-3 mb-4">{t('widgets.horoscope_label')}</h3>
      <div className="flex flex-wrap gap-1 mb-3">
        {horoscopes.map((h, i) => (
          <button key={i} onClick={() => setSelected(i)} className={`w-7 h-7 text-base rounded-md transition-colors ${selected === i ? 'bg-purple-100 dark:bg-purple-900/50' : 'hover:bg-gray-100 dark:hover:bg-gray-800'}`} title={h.sign}>
            {h.symbol}
          </button>
        ))}
      </div>
      {current && (
        <div>
          <p className="text-sm font-bold text-gray-900 dark:text-gray-100 mb-1">{current.symbol} {current.sign}</p>
          <p className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed">{current.text}</p>
        </div>
      )}
    </div>
  );
}
